import { AscButtonSharePropsI } from "./AscButtonShare.type";
import styles from "./AscButtonShare.module.scss";
import AscButtonShareFacebook from "./AscButtonShareFacebook/AscButtonShareFacebook";
import classNames from "classnames";
import AscButtonShareTwitter from "./AscButtonShareTwitter/AscButtonShareTwitter";
import AscButtonShareLinkedin from "./AscButtonShareLinkedin/AscButtonShareLinkedin";
import AscButtonShareEmail from "./AscButtonShareEmail/AscButtonShareEmail";
import AscButtonShareCopyLink from "./AscButtonShareCopyLink/AscButtonShareCopyLink";

function AscButtonShare({
  type,
  className,
  label,
  link,
}: AscButtonSharePropsI) {
  const buttonProps = {
    className: classNames(styles.button, className),
    label: label,
    link: link,
  };

  switch (type) {
    case "linkedin":
      return <AscButtonShareLinkedin {...buttonProps} />;
    case "twitter":
      return <AscButtonShareTwitter {...buttonProps} />;
    case "facebook":
      return <AscButtonShareFacebook {...buttonProps} />;
    case "email":
      return <AscButtonShareEmail {...buttonProps} />;
    case "copy-link":
      return <AscButtonShareCopyLink {...buttonProps} />;
  }
}

export default AscButtonShare;
